// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quiz .description h6[data-v-113022ea],.quiz .navs[data-v-113022ea],.quiz .question-head[data-v-113022ea]{color:var(--lms-tenant)}", ""]);
// Exports
module.exports = exports;
